import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./AgregarProducto.css";
  const API = process.env.REACT_APP_API_URL

export default function AgregarProducto() {
  const navigate = useNavigate();
  const token = localStorage.getItem("token");

  // Estados
  const [datos, setDatos] = useState([]);
  const [producto, setProducto] = useState({
    nombre: "",
    descripcion: "",
    precio: "",
    precioAnterior:"",
    stock: "",
    marca: "",
    sku: "",
    categoriaId: ""
  });
  const [cargando, setCargando] = useState(false);

  // Manejador único para todos los inputs
  const handleChange = (e) => {
    const { name, value } = e.target;
    setProducto(prev => ({ ...prev, [name]: value }));
  };

  const renovarToken = async () => {
    console.log("Intentando renovar sesión...");
    try {
      const res = await fetch( API + "/user/refresh",{
         method:"POST",

          credentials: "include"
      });
      if (res.ok) {
        const data = await res.json();
        localStorage.setItem("token", data.accessToken);
        return true;
      }
    } catch (error) {
      console.error("Error crítico al renovar token:", error);
    }
    return false;
  };

  const traerCategorias = async () => {
    try {
      const response = await fetch( API + "/categorias/traerCategorias",{
      })
      const data = await response.json();
      setDatos(data.datos || []);
    } catch (error) {
      console.error("Error al cargar categorías", error);
    }
  };

  useEffect(() => {
    traerCategorias();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setCargando(true);

    const payload = {
      ...producto,
      precio: parseFloat(producto.precio),
      stock: parseInt(producto.stock),
      categoriaId: parseInt(producto.categoriaId),
    };

    try {
      const response = await fetch(API + "/productos/crearProductos", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`,
        },
        body: JSON.stringify(payload),
      });

       if (response.status === 403) {
        const renovado = await renovarToken();
        if (renovado) return await handleSubmit(); 
        return;
      }

      const data = await response.json();

      if (response.ok) {
        alert("Producto creado correctamente ✅");
        navigate(`/AgregarImagenesProductos/${data.respuesta}`);
      } else {
        alert("Error al crear el producto ❌");
      }
    } catch (error) {
      alert("Error de conexión con el servidor");
    } finally {
      setCargando(false);
    }
  };

  return (
    <div className="add-product-page">
      <div className="form-wrapper">
        <header className="form-header">
          <h1>Nuevo Producto</h1>
          <p>Completa la información básica para continuar con las imágenes</p>
        </header>

        <form onSubmit={handleSubmit} className="modern-form">
          <div className="form-grid">
            {/* Columna Izquierda */}
            <div className="form-group">
              <label>Nombre del Producto</label>
              <input name="nombre" type="text" placeholder="Ej: Smartphone Galaxy" value={producto.nombre} onChange={handleChange} required />
            </div>

            <div className="form-group">
              <label>Categoría</label>
              <select name="categoriaId" value={producto.categoriaId} onChange={handleChange} required>
                <option value="">Selecciona una categoría</option>
                {datos.map((el) => (
                  <option key={el.id} value={el.id}>{el.nombre}</option>
                ))}
              </select>
            </div>

            <div className="form-group">
              <label>Precio ($)</label>
              <input name="precio" type="number" placeholder="0.00" value={producto.precio} onChange={handleChange} required />
            </div>


            <div className="form-group">
              <label>Precio Anterior si no tiene dejalo en blanco ($)</label>
              <input name="precioAnterior" type="number" placeholder="0.00" value={producto.precioAnterior} onChange={handleChange} />
            </div>

            <div className="form-group">
              <label>Stock Disponible</label>
              <input name="stock" type="number" placeholder="Cantidad" value={producto.stock} onChange={handleChange} required />
            </div>

            <div className="form-group">
              <label>Marca</label>
              <input name="marca" type="text" placeholder="Ej: Samsung" value={producto.marca} onChange={handleChange} />
            </div>

            <div className="form-group">
              <label>SKU (Código Interno)</label>
              <input name="sku" type="text" placeholder="Código de barras" value={producto.sku} onChange={handleChange} />
            </div>
          </div>

          <div className="form-group full-width">
            <label>Descripción Detallada</label>
            <textarea name="descripcion" placeholder="Describe las características principales..." value={producto.descripcion} onChange={handleChange} required />
          </div>

          <button type="submit" className={`submit-btn ${cargando ? 'loading' : ''}`} disabled={cargando}>
            {cargando ? "Guardando..." : "Siguiente: Subir Imágenes →"}
          </button>
        </form>
      </div>
    </div>
  );
}